import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { Card, CardContent } from "@/components/ui/card";
import { PendingBatch, PendingItemStatus } from "@/services/price-remark/types";

import { ITEM_SITUATIONS } from "./situation-styles";

const AXIS_TICK = { fill: "#6B7280", fontSize: 11 };
const CHART_HEIGHT = 280;

const SERIES: PendingItemStatus[] = [
  "NAO_INICIADO",
  "PARCIAL",
  "FALHA_IMPRESSAO",
  "JUSTIFICADO",
  "SEM_ESTOQUE",
  "CONCLUIDO",
];

interface BatchCompositionChartProps {
  batches: PendingBatch[];
}

export function BatchCompositionChart({ batches }: BatchCompositionChartProps) {
  if (batches.length === 0) return null;

  const data = batches
    .slice()
    .reverse()
    .map((batch) => ({
      lote: batch.batch.slice(5).split("-").reverse().join("/"),
      NAO_INICIADO: batch.notStarted,
      PARCIAL: batch.partial,
      FALHA_IMPRESSAO: batch.printFailure,
      JUSTIFICADO: batch.justified,
      SEM_ESTOQUE: batch.outOfStock,
      CONCLUIDO: batch.completed,
    }));

  return (
    <Card>
      <CardContent className="p-4">
        <div className="mb-3">
          <p className="text-sm font-semibold text-gray-900">
            Composição por lote
          </p>
          <p className="text-xs text-gray-500">
            Situação dos itens que exigem etiqueta, lote a lote.
          </p>
        </div>
        <div
          className="w-full overflow-hidden"
          style={{ height: CHART_HEIGHT }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 4, right: 16, bottom: 4, left: 8 }}
            >
              <CartesianGrid horizontal={false} stroke="#F3F4F6" />
              <XAxis type="number" tick={AXIS_TICK} allowDecimals={false} />
              <YAxis
                type="category"
                dataKey="lote"
                width={56}
                tick={AXIS_TICK}
                interval={0}
              />
              <Tooltip
                formatter={(value: number, name: string) => [
                  value,
                  ITEM_SITUATIONS[name as PendingItemStatus]?.label ?? name,
                ]}
                labelFormatter={(label) => `Lote ${label}`}
              />
              <Legend
                formatter={(value: string) =>
                  ITEM_SITUATIONS[value as PendingItemStatus]?.label ?? value
                }
                wrapperStyle={{ fontSize: 11 }}
              />
              {SERIES.map((status) => (
                <Bar
                  key={status}
                  dataKey={status}
                  stackId="lote"
                  fill={ITEM_SITUATIONS[status].dot}
                  maxBarSize={26}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}

export default BatchCompositionChart;
